import { createAnimation, Animation } from '@ionic/core';

export function FadeEnterTransition(rootElement: HTMLElement): Animation
{
    const fadeEnterAnimation_Backdrop = createAnimation()
        .addElement(document.querySelector('ion-backdrop'))
        .beforeStyles({ 'opacity': 0 })
        .fromTo('opacity', 0, 0.01)
        .duration(100)
        .easing('cubic-bezier(0.000, 0.670, 0.580, 1.005)');

    const fadeEnterAnimation_Modal = createAnimation()
        .addElement(rootElement.querySelector('.modal-wrapper'))
        .beforeStyles({ 'opacity': 0.0 })
        .fromTo('opacity', 0.1, 1)
        .duration(500)
        .easing('cubic-bezier(0.000, 0.670, 0.580, 1.005)');


    const parent = createAnimation()
        .addAnimation([ fadeEnterAnimation_Backdrop, fadeEnterAnimation_Modal ]);

        return parent;      
}

export function FadeLeaveTransition(rootElement: HTMLElement): Animation
{
    const fadeEnterAnimation_Backdrop = createAnimation()
        .addElement(document.querySelector('ion-backdrop'))
        .fromTo('opacity', 0.01, 0)
        .duration(350)
        .easing('cubic-bezier(0.475, -0.005, 1.000, 0.425)');

    const fadeEnterAnimation_Modal = createAnimation()
        .addElement(rootElement.querySelector('.modal-wrapper'))
        .beforeStyles({ 'opacity': 1 })
        .fromTo('opacity', 1, 0.1)
        .duration(250)
        .easing('cubic-bezier(0.475, -0.005, 1.000, 0.425)');


    const parent = createAnimation()
        .addAnimation([ fadeEnterAnimation_Backdrop, fadeEnterAnimation_Modal ]);

    return parent;
}